import {$http} from './http.js'
import  {$https} from './https.js'

const HomeShowAllNr=(url,data=null,method)=>{
   return  $https({
    url,
    data,
    method
  })
}
const homeShowAllXx=(url,data=null,method)=>{
  return  $https({
   url,
   data,
   method
 })
}
const Loginidentfy=(url,data=null,method)=>{
    return  $https({
        url,
        data,
        method
      }) 
}
const dateadrees=(url,data=null,method)=>{
  return  $http({
      url,
      data,
      method
    }) 
}

const dateadreesp=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method
    }) 
}

const sendmessage=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method
    }) 
}
const uploadfilezi=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method,
      // type:1
    }) 
}

const uploadfileown=(url,data=null,method)=>{
  return  $http({
      url,
      data,
      method,
      // type:1
    }) 
}

const uploadfilemore=(url,data=null,method)=>{
  return  $http({
      url,
      data,
      method,
      type:1
    }) 
}

const uploadpdfmore=(url,data=null,method)=>{
  return  $http({
      url,
      data,
      method,
      type:1
    }) 
}

const showaddres=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method
    }) 
}

const showaddresp=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method
    }) 
}
const ShowExamsub=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method
    }) 
}

const showinfo=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method
    }) 
}
const dynamicmoreinfo=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method
    }) 
}
const uploadfilemoreinfo=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method
    }) 
}
const registration=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method
    }) 
}
const achievementp=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method
    }) 
}
const findExamAchievement=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method
    }) 
}
const dynamicmoreiptS=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method
    }) 
}

const ShowScore=(url,data=null,method)=>{
  return  $https({
      url,
      data,
      method
    }) 
}
export {findExamAchievement,ShowScore,dynamicmoreiptS,dateadreesp,achievementp,dynamicmoreinfo,ShowExamsub,showaddresp,registration,uploadfilemoreinfo,showinfo,showaddres,uploadfileown,uploadpdfmore,uploadfilemore,HomeShowAllNr,Loginidentfy,homeShowAllXx,dateadrees,uploadfilezi,sendmessage}